"use strict";
var appn;
(function (appn) {
    var dateFilterMini;
    (function (dateFilterMini) {
        function init(dfilter, customFilterCallBack) {
            if (!dfilter) {
                const state = getStateOrDefaultAsString();
                dfilter = state ? state : 'ThisMonth';
            }
            setValueFromString(dfilter);
            addEvents(customFilterCallBack);
        }
        dateFilterMini.init = init;
        function addEvents(customFilterCallBack) {
            $('.container-date-filter-mini #customFilter').off().on('click', function (e) {
                e.preventDefault();
                const registerItem = {
                    elementId: 'appnDateFilterMini',
                    value: getValueAsString()
                };
                appn.saveMeState.createOrUpdateRegister(registerItem);
                if (customFilterCallBack)
                    customFilterCallBack();
            });
        }
        function updateActiveOptions(value) {
            const appnDateFilterMini = $('.appnDateFilterMini');
            if (!value)
                return;
            const bits = value.split('|');
            if (!bits || !bits[0])
                return;
            appnDateFilterMini.val(bits[0]);
            appn.dataTable.uncheckAllRowsBox();
        }
        dateFilterMini.updateActiveOptions = updateActiveOptions;
        function getStateOrDefault() {
            const appnDateFilterMini = $('.appnDateFilterMini');
            const dateFilterValue = appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnDateFilterMini), getValueAsString()).value;
            const dateFilterValues = getValue(dateFilterValue);
            if (dateFilterValues.type === 'CustomRange')
                $('.container-custom-filter').show();
            else
                $('.container-custom-filter').hide();
            return dateFilterValues;
        }
        dateFilterMini.getStateOrDefault = getStateOrDefault;
        function getStateOrDefaultAsString() {
            const appnDateFilterMini = $('.appnDateFilterMini');
            return appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnDateFilterMini), getValueAsString()).value;
        }
        dateFilterMini.getStateOrDefaultAsString = getStateOrDefaultAsString;
        function getValueAsString() {
            const activeValue = getValue();
            if (!activeValue)
                return appn.emptyString;
            return activeValue.type + '|' + activeValue.fromDate + '|' + activeValue.toDate;
        }
        dateFilterMini.getValueAsString = getValueAsString;
        function getValue(valueString) {
            const filterValues = {
                type: 'ThisMonth',
                fromDate: appn.emptyString,
                toDate: appn.emptyString
            };
            if (valueString) {
                const bits = valueString.split('|');
                filterValues.type = bits[0];
                filterValues.fromDate = bits[1];
                filterValues.toDate = bits[2];
                return filterValues;
            }
            const appnDateFilterMini = $('.appnDateFilterMini');
            const type = appnDateFilterMini.val();
            if (type)
                filterValues.type = type;
            const containerDateFilterMini = $('.container-date-filter-mini');
            filterValues.fromDate = containerDateFilterMini.find('#FromDate').val();
            filterValues.toDate = containerDateFilterMini.find('#ToDate').val();
            return filterValues;
        }
        dateFilterMini.getValue = getValue;
        function isAtLeastOneActive() {
            if ($('.appnDateFilterMini').val())
                return true;
            return false;
        }
        function setValueFromString(value) {
            if (!value)
                return;
            if (isAtLeastOneActive() && getValueAsString() === value)
                return;
            const bits = value.split('|');
            const appnDateFilterMini = $('.appnDateFilterMini');
            appnDateFilterMini.val(bits[0]);
            const containerDateFilterMini = $('.container-date-filter-mini');
            if (bits[1])
                containerDateFilterMini.find('#FromDate').val(bits[1]);
            if (bits[2])
                containerDateFilterMini.find('#ToDate').val(bits[2]);
            appn.dataTable.uncheckAllRowsBox();
        }
        dateFilterMini.setValueFromString = setValueFromString;
        function reset() {
            setValueFromString('ThisMonth');
        }
        dateFilterMini.reset = reset;
    })(dateFilterMini = appn.dateFilterMini || (appn.dateFilterMini = {}));
})(appn || (appn = {}));
